import { Outlet } from "react-router-dom"
const MainManPower = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainManPower;